import { render, staticRenderFns } from "./ProductCtmLogo.vue?vue&type=template&id=c58eac84&scoped=true&"
import script from "./ProductCtmLogo.vue?vue&type=script&lang=ts&"
export * from "./ProductCtmLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c58eac84",
  null
  
)

export default component.exports